import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ngClassObject } from '../../../types';
import { PSelectItem } from './p-select-item.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'p-select',
  templateUrl: './p-select.component.html',
  styleUrls: ['./p-select.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PSelectComponent {
  @Input() id!: string;
  @Input() label!: string;
  @Input() items!: PSelectItem[];
  @Input() size: 'small' | 'default' = 'default';
  @Input() isCapitalize = false;
  @Input() selectedItem!: PSelectItem;
  @Input() placeholder?: string;
  @Input() required = false;

  @Output() selected = new EventEmitter<PSelectItem>();
  @Output() blur = new EventEmitter<void>();

  public itemSelected(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedItem = this.items.find(
      (item) => item.value === selectElement.value,
    );

    if (selectedItem) {
      this.selected.emit(selectedItem);
    } else {
      this.selected.emit({ value: null, label: null });
    }
  }

  get classes(): ngClassObject<string> {
    return {
      'form-select-sm': this.size === 'small',
    };
  }
}
